// document.addEventListener('DOMContentLoaded', () => {
//     const swiperEl = document.querySelector('.proiecte-swiper-horizontal');

//     const swiperHorizontal = new Swiper(swiperEl, {
//         direction: 'horizontal',
//         slidesPerView: 'auto',
//         spaceBetween: 0,

//         freeMode: {
//             enabled: true,
//             momentum: false,
//         },

//         mousewheel: {
//             enabled: true,
//             forceToAxis: true,
//             sensitivity: 0.15,
//             thresholdDelta: 20,
//             thresholdTime: 300,
//         },

//         grabCursor: false,
//         navigation: false,
//         pagination: false,
//     });

//     const cursor = document.querySelector('.custom-cursor');
//     const EDGE_LIMIT = 100;

//     document.addEventListener('mousemove', (e) => {
//         const y = e.clientY;
//         const windowHeight = window.innerHeight;

//         const inSafeZone =
//             y > EDGE_LIMIT &&
//             y < windowHeight - EDGE_LIMIT &&
//             swiperEl.matches(':hover');

//         if (inSafeZone) {
//             cursor.classList.add('active');
//             document.body.classList.add('cursor-hidden');
//         } else {
//             cursor.classList.remove('active');
//             document.body.classList.remove('cursor-hidden');
//         }

//         cursor.style.left = e.clientX + 'px';
//         cursor.style.top = e.clientY + 'px';
//     });
// });

// document.addEventListener('DOMContentLoaded', () => {
//     const body = document.body;

//     // Run ONLY if body has the required class
//     if (!body.classList.contains('scroll-horizontal')) return;

//     // Get Swiper container
//     const swiperEl = document.querySelector('.proiecte-swiper-horizontal');

//     // Initialize Swiper (no mousewheel inside Swiper)
//     const swiperHorizontal = new Swiper(swiperEl, {
//         direction: 'horizontal',
//         slidesPerView: 'auto',
//         spaceBetween: 0,

//         freeMode: {
//             enabled: true,
//             momentum: false, // precise control
//         },

//         allowTouchMove: true,
//         grabCursor: false,
//         navigation: false,
//         pagination: false,
//     });

//     // Current horizontal position
//     let currentTranslate = 0;

//     // Listen to mouse wheel ONLY on this body
//     body.addEventListener('wheel', (e) => {
//         e.preventDefault(); // stop vertical page scroll

//         const speed = 0.35; // adjust sensitivity here

//         // Convert vertical scroll to horizontal movement
//         currentTranslate -= e.deltaY * speed;

//         // Clamp movement within Swiper bounds
//         const maxTranslate = 0;
//         const minTranslate = swiperHorizontal.maxTranslate();

//         currentTranslate = Math.max(
//             minTranslate,
//             Math.min(maxTranslate, currentTranslate)
//         );

//         // Apply transform
//         swiperHorizontal.setTranslate(currentTranslate);
//         swiperHorizontal.updateProgress();
//         swiperHorizontal.updateActiveIndex();
//         swiperHorizontal.updateSlidesClasses();
//     }, { passive: false });
// });

document.addEventListener('DOMContentLoaded', () => {
    const body = document.body;

    // Run ONLY if body has the required class
    if (!body.classList.contains('scroll-horizontal')) return;

    const swiperEl = document.querySelector('.proiecte-swiper-horizontal');
    const cursor = document.querySelector('.custom-cursor');

    const EDGE_LIMIT = 100;
    const DESKTOP_MIN_WIDTH = 1024;

    let swiperHorizontal = null;
    let currentTranslate = 0;

    // Keep references so we can add/remove listeners cleanly
    const onWheel = (e) => {
        // If we are below 1024px, do nothing (allow normal vertical scrolling)
        if (window.innerWidth < DESKTOP_MIN_WIDTH) return;

        e.preventDefault(); // stop vertical page scroll on desktop horizontal mode

        const speed = 0.35; // adjust sensitivity here

        // Convert vertical scroll to horizontal movement
        currentTranslate -= e.deltaY * speed;

        // Clamp movement within Swiper bounds
        const maxTranslate = 0;
        const minTranslate = swiperHorizontal.maxTranslate();

        currentTranslate = Math.max(minTranslate, Math.min(maxTranslate, currentTranslate));

        // Apply transform + update internal state
        swiperHorizontal.setTranslate(currentTranslate);
        swiperHorizontal.updateProgress();
        swiperHorizontal.updateActiveIndex();
        swiperHorizontal.updateSlidesClasses();
    };

    const onMouseMove = (e) => {
        // If we are below 1024px, ensure cursor is disabled and exit
        if (window.innerWidth < DESKTOP_MIN_WIDTH) {
            if (cursor) cursor.classList.remove('active');
            document.body.classList.remove('cursor-hidden');
            return;
        }

        if (!cursor || !swiperEl) return;

        const y = e.clientY;
        const windowHeight = window.innerHeight;

        const inSafeZone =
            y > EDGE_LIMIT &&
            y < windowHeight - EDGE_LIMIT &&
            swiperEl.matches(':hover');

        if (inSafeZone) {
            cursor.classList.add('active');
            document.body.classList.add('cursor-hidden');
        } else {
            cursor.classList.remove('active');
            document.body.classList.remove('cursor-hidden');
        }

        cursor.style.left = e.clientX + 'px';
        cursor.style.top = e.clientY + 'px';
    };

    const enableDesktopHorizontal = () => {
        if (!swiperEl || swiperHorizontal) return;

        // Initialize Swiper for desktop only
        swiperHorizontal = new Swiper(swiperEl, {
            direction: 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 0,
            freeMode: {
                enabled: true,
                momentum: false, // precise control
            },
            allowTouchMove: true,
            grabCursor: false,
            navigation: false,
            pagination: false,
        });

        // Reset translate tracking
        currentTranslate = swiperHorizontal.getTranslate();

        // Enable wheel hijack (horizontal scrolling)
        body.addEventListener('wheel', onWheel, { passive: false });

        // Enable custom cursor only on desktop
        document.addEventListener('mousemove', onMouseMove);
    };

    const disableDesktopHorizontal = () => {
        // Remove wheel hijack so vertical scrolling works normally
        body.removeEventListener('wheel', onWheel);

        // Disable custom cursor
        document.removeEventListener('mousemove', onMouseMove);
        document.body.classList.remove('cursor-hidden');
        if (cursor) cursor.classList.remove('active');

        // Destroy Swiper instance if it exists
        if (swiperHorizontal) {
            swiperHorizontal.destroy(true, true);
            swiperHorizontal = null;
        }

        // Reset any transform that Swiper left behind
        if (swiperEl) {
            swiperEl.style.transform = '';
        }

        // Reset translate tracking
        currentTranslate = 0;
    };

    const syncMode = () => {
        if (window.innerWidth >= DESKTOP_MIN_WIDTH) {
            enableDesktopHorizontal();
        } else {
            disableDesktopHorizontal();
        }
    };

    // Initial mode
    syncMode();

    // Switch mode on resize (desktop <-> mobile/tablet)
    window.addEventListener('resize', syncMode);
});




// WEBPACK FOOTER //
// ./resources/js/modules/projects-horizontal.js